import { render, staticRenderFns } from "./EditorActionHeader.vue?vue&type=template&id=85417cb8"
import script from "./EditorActionHeader.vue?vue&type=script&lang=js"
export * from "./EditorActionHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports